
import { commonConstants } from '../constant/common.constants';
import functionCommon from "../common/function";
import { commonService } from '../services/common.service';
import CONSTANT from '../constant/constant';
const _errorCode = CONSTANT.errorCode;

export const getSecretKey = (url) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }
    return dispatch => {
        commonService.getKey(url).then(
            res => {
                if (!res) return;
                switch (res['http_code']) {
                    case _errorCode.APISuccess:
                        dispatch(success(res['result']));
                        break;
    
                    case _errorCode.TOKENExpired:
                        functionCommon.logout();
                        break;
                    
                    case _errorCode.APIInvalids:
                        functionCommon.logout();
                        break;
    
                    default:
                        window.location = '/error/404';
                        break;
                }
            }
        )
    };

    function success(getSecretKey) {
        return { type: commonConstants.SECRET_KEY_SUCCESS, getSecretKey };
    }
}

export const exportFileAction = (url, param) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }
    return dispatch => {
        commonService.getKey(url['urlGetkey']).then(
            res => {
                if (!res) return;
                if (res['http_code'] === _errorCode.APIInvalids) return functionCommon.logout();
                param['secretKey'] = res.result['secretKey'];
                commonService.exportFile(url['urlDownfile'], param);
            }
        )
    };
}

export const importFileAction = (url, param) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }
    return dispatch => {
        commonService.getKey(url['urlGetkey']).then(
            res => {
                if (!res) return;
                if (res['http_code'] === _errorCode.APIInvalids) return functionCommon.logout();
                commonService.importFile(url['urlDownfile'], {file: param, secretKey: res.result['secretKey']});
            }
        )
    };
}

export const importErOmFileAction = (url, param, _month, _year, _supervisorId, _approverId, _currentUrl) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }
    return dispatch => {
        commonService.getKey(url['urlGetkey']).then(
            res => {
                if (!res) return;
                if (res['http_code'] === _errorCode.APIInvalids) return functionCommon.logout();
                commonService.importErOmFile(url['urlDownfile'], {file: param, secretKey: res.result['secretKey'], month: _month, year: _year, superviorId: _supervisorId, approverId: _approverId, currentUrl: _currentUrl});
            }
        )
    };
}

export const getApproveSecretKey = (url, param) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }
    return dispatch => {
        commonService.getKey(url['urlGetkey']).then(
            res => {
                if (!res) return;
                switch (res['http_code']) {
                    case _errorCode.APISuccess:
                        dispatch(success(res['result']));
                        break;
    
                    case _errorCode.APIInvalids:
                        functionCommon.logout();
                        break;
                }
            }
        )
    };

    function success(getSecretKey) {
        return { type: commonConstants.SECRET_KEY_SUCCESS, getSecretKey };
    }
}

export const exportAllEmployee = (url, param) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }
    return dispatch => {
        commonService.PostKey(url['urlGetkey'], param).then(
            res => {
                if (!res) return;
                if (res['http_code'] === _errorCode.APIInvalids) return functionCommon.logout();
                param['secretKey'] = res.result['secretKey'];
                commonService.exportFile(url['urlDownfile'], param);
            }
        )
    };
}

export const exportErStatus = (url, param) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }
    return (dispatch) => {
        commonService.PostKey(url["urlGetkey"], param).then((res) => {
            if (!res) return;
            if (res["http_code"] === _errorCode.APIInvalids) return functionCommon.logout();
            else if (res["http_code"] === _errorCode.APISuccess) {
                param["secretKey"] = res.result["secretKey"];
                commonService.exportFile(url["urlDownfile"], param);
            } else {
                window.location = "/error/404";
            }
        });
    };
};
